import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@wizbii/angular-utilities';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CkEditorService {
  ckEditorLoaded$ = new BehaviorSubject<boolean>(false);

  documentEditor: any;

  config = {
    toolbar: {
      items: [
        'heading',
        '|',
        'fontSize',
        'fontFamily',
        'fontBackgroundColor',
        'fontColor',
        '|',
        'bold',
        'italic',
        'underline',
        'strikethrough',
        'highlight',
        '|',
        'alignment',
        '|',
        'numberedList',
        'bulletedList',
        '|',
        'indent',
        'outdent',
        '|',
        'todoList',
        'link',
        'blockQuote',
        'imageUpload',
        'insertTable',
        'mediaEmbed',
        '|',
        'undo',
        'redo',
      ],
    },
    language: 'fr',
    image: {
      toolbar: ['imageTextAlternative', 'imageStyle:full', 'linkImage'],
      styles: ['full'],
    },
    table: {
      contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
    },
    licenseKey: '',
    link: { addTargetToExternalLinks: true, defaultProtocol: 'https://' },
  };

  constructor(@Inject(DOCUMENT) readonly document: any, @Inject(WINDOW) private readonly window: any) {}

  loadDocumentEditor(): void {
    if (this.ckEditorLoaded$.value) {
      return;
    }

    const jsElmCK = this.document.createElement('script');
    jsElmCK.type = 'application/javascript';
    jsElmCK.src = '/assets/ckeditor/ckeditor.js';
    this.document.body.appendChild(jsElmCK);
    jsElmCK.onload = () => {
      this.documentEditor = this.window.DecoupledDocumentEditor;
      this.ckEditorLoaded$.next(true);
    };
  }
}
